// /home/labdoo/zitech-nexus/frontend/src/pages/admin/AdminApplicationDetail.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { jobsAPI } from '../../services/api';
import './AdminApplicationDetail.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  View: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Download: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 17L12 21L20 17" />
      <path d="M12 3V15M12 15L8 11M12 15L16 11" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  File: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="aad-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Error: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Email: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Phone: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Portfolio: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  LinkedIn: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  Link: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  User: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Briefcase: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
  Pdf: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Image: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  OpenNew: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  ),
};

const AdminApplicationDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [application, setApplication] = useState<any>(null);
  const [updating, setUpdating] = useState(false);
  const [showFileViewer, setShowFileViewer] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [pdfLoadError, setPdfLoadError] = useState(false);

  useEffect(() => {
    fetchApplication();
  }, [id]);

  const fetchApplication = async () => {
    try {
      const response = await jobsAPI.getApplication(parseInt(id!));
      setApplication(response.data);
    } catch (error) {
      console.error('Error fetching application:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (status: string) => {
    if (!window.confirm(`Change application status to ${status}? The applicant will be notified via email.`)) {
      return;
    }
    
    setUpdating(true);
    try {
      await jobsAPI.updateApplicationStatus(parseInt(id!), status);
      fetchApplication();
      alert('Status updated successfully!');
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status');
    } finally {
      setUpdating(false);
    }
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'pending': return '#f59e0b';
      case 'reviewed': return '#0ea5e9';
      case 'shortlisted': return '#8b5cf6';
      case 'interviewed': return '#06b6d4';
      case 'accepted': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusBackground = (status: string) => {
    switch(status) {
      case 'pending': return '#fef3c7';
      case 'reviewed': return '#dbeafe';
      case 'shortlisted': return '#ede9fe';
      case 'interviewed': return '#cffafe';
      case 'accepted': return '#d1fae5';
      case 'rejected': return '#fee2e2';
      default: return '#f3f4f6';
    }
  };

  const getStatusLabel = (status: string) => {
    switch(status) {
      case 'pending': return 'Pending Review';
      case 'reviewed': return 'Reviewed';
      case 'shortlisted': return 'Shortlisted';
      case 'interviewed': return 'Interviewed';
      case 'accepted': return 'Accepted';
      case 'rejected': return 'Rejected';
      default: return status;
    }
  };

  const getFileUrl = (filePath: string) => {
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return `${baseUrl}${filePath}`;
  };

  const getFileExtension = (fileName: string) => {
    return fileName.split('.').pop()?.toLowerCase() || '';
  };

  const isPdfFile = (fileName: string) => {
    return getFileExtension(fileName) === 'pdf';
  };

  const isImageFile = (fileName: string) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExtensions.includes(getFileExtension(fileName));
  };

  const openFileViewer = (fileUrl: string, fileName: string) => {
    setSelectedFileUrl(fileUrl);
    setSelectedFileName(fileName);
    setFileType(getFileExtension(fileName));
    setPdfLoadError(false);
    setShowFileViewer(true);
    document.body.style.overflow = 'hidden';
  };

  const closeFileViewer = () => {
    setShowFileViewer(false);
    setSelectedFileUrl('');
    setSelectedFileName('');
    setFileType('');
    setPdfLoadError(false);
    document.body.style.overflow = 'auto';
  };

  const handleDownload = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePdfError = () => {
    setPdfLoadError(true);
  };

  if (loading) {
    return (
      <div className="aad-loading-container">
        <div className="aad-spinner">
          <Icons.Spinner />
        </div>
        <p className="aad-loading-text">Loading application details...</p>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="aad-error-container">
        <div className="aad-error-icon">
          <Icons.Error />
        </div>
        <h2 className="aad-error-title">Application Not Found</h2>
        <p className="aad-error-text">The application you're looking for doesn't exist or has been removed.</p>
        <button className="aad-error-btn" onClick={() => navigate('/dashboard/admin/applications')}>
          <Icons.Back />
          Back to Applications
        </button>
      </div>
    );
  }

  // File Viewer Full Page
  if (showFileViewer) {
    const isPdf = fileType === 'pdf';
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(fileType);
    
    return (
      <div className="aad-file-viewer-page">
        {/* Header */}
        <div className="aad-file-viewer-page-header">
          <div className="aad-file-viewer-page-header-left">
            <button className="aad-file-viewer-page-back" onClick={closeFileViewer}>
              <Icons.Back />
              Back to Application
            </button>
            <span className="aad-file-viewer-page-title">
              {isPdf ? <Icons.Pdf /> : isImage ? <Icons.Image /> : <Icons.File />}
              {selectedFileName}
            </span>
          </div>
          <div className="aad-file-viewer-page-header-actions">
            <button 
              className="aad-file-viewer-page-open"
              onClick={() => window.open(selectedFileUrl, '_blank')}
            >
              <Icons.OpenNew />
              Open in New Tab
            </button>
            <button 
              className="aad-file-viewer-page-download"
              onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
            >
              <Icons.Download />
              Download
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="aad-file-viewer-page-body">
          {isPdf ? (
            <div className="aad-file-viewer-page-pdf-container">
              {!pdfLoadError ? (
                <>
                  {/* Try embed first - better than iframe for PDFs */}
                  <embed
                    src={selectedFileUrl}
                    type="application/pdf"
                    className="aad-file-viewer-page-pdf"
                    onError={handlePdfError}
                  />
                  {/* Fallback if embed fails */}
                  {pdfLoadError && (
                    <div className="aad-file-viewer-page-pdf-fallback">
                      <Icons.Pdf />
                      <p>Unable to display PDF directly.</p>
                      <div className="aad-file-viewer-page-pdf-fallback-actions">
                        <button 
                          className="aad-file-viewer-page-download-btn"
                          onClick={() => window.open(selectedFileUrl, '_blank')}
                        >
                          <Icons.OpenNew />
                          Open in New Tab
                        </button>
                        <button 
                          className="aad-file-viewer-page-download-btn"
                          onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
                        >
                          <Icons.Download />
                          Download PDF
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="aad-file-viewer-page-pdf-fallback">
                  <Icons.Pdf />
                  <p>Unable to display PDF directly.</p>
                  <div className="aad-file-viewer-page-pdf-fallback-actions">
                    <button 
                      className="aad-file-viewer-page-download-btn"
                      onClick={() => window.open(selectedFileUrl, '_blank')}
                    >
                      <Icons.OpenNew />
                      Open in New Tab
                    </button>
                    <button 
                      className="aad-file-viewer-page-download-btn"
                      onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
                    >
                      <Icons.Download />
                      Download PDF
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : isImage ? (
            <div className="aad-file-viewer-page-image-container">
              <img 
                src={selectedFileUrl} 
                alt={selectedFileName} 
                className="aad-file-viewer-page-image"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const parent = e.currentTarget.parentElement;
                  if (parent) {
                    const errorMsg = document.createElement('p');
                    errorMsg.className = 'aad-file-viewer-page-error';
                    errorMsg.textContent = 'Failed to load image. Please try downloading it instead.';
                    parent.appendChild(errorMsg);
                  }
                }}
              />
            </div>
          ) : (
            <div className="aad-file-viewer-page-placeholder">
              <Icons.File />
              <p>This file type cannot be previewed directly.</p>
              <button 
                className="aad-file-viewer-page-download-btn"
                onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
              >
                <Icons.Download />
                Download File
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  const resumeFileName = application.resume?.split('/').pop() || 'resume.pdf';
  const resumeUrl = getFileUrl(application.resume);
  const isPdf = isPdfFile(resumeFileName);
  const isImage = isImageFile(resumeFileName);

  return (
    <div className="aad-container">
      {/* Header */}
      <div className="aad-header">
        <button className="aad-back-btn" onClick={() => navigate('/dashboard/admin/applications')}>
          <Icons.Back />
          Back to Applications
        </button>
        <div className="aad-header-content">
          <h1 className="aad-title">Application #{application.id}</h1>
          <div className="aad-header-meta">
            <span className="aad-meta-item">
              <Icons.Briefcase />
              {application.job_title}
            </span>
            <span className="aad-meta-divider">|</span>
            <span className="aad-meta-item">
              <Icons.User />
              {application.full_name}
            </span>
            <span className="aad-meta-divider">|</span>
            <span className="aad-meta-item">
              <Icons.Calendar />
              {new Date(application.applied_at).toLocaleDateString('en-US', { 
                month: 'long', 
                day: 'numeric', 
                year: 'numeric' 
              })}
            </span>
          </div>
        </div>
        <div className="aad-header-status">
          <span 
            className="aad-status-badge-large"
            style={{ 
              background: getStatusBackground(application.status),
              color: getStatusColor(application.status)
            }}
          >
            <span className="aad-status-dot" style={{ background: getStatusColor(application.status) }}></span>
            {getStatusLabel(application.status)}
          </span>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="aad-stats-bar">
        <div className="aad-stat-item">
          <span className="aad-stat-label">Applicant</span>
          <span className="aad-stat-value">{application.full_name}</span>
        </div>
        <div className="aad-stat-divider"></div>
        <div className="aad-stat-item">
          <span className="aad-stat-label">Email</span>
          <span className="aad-stat-value aad-stat-email">
            <a href={`mailto:${application.email}`}>
              <Icons.Email />
              {application.email}
            </a>
          </span>
        </div>
        <div className="aad-stat-divider"></div>
        <div className="aad-stat-item">
          <span className="aad-stat-label">Phone</span>
          <span className="aad-stat-value">
            <a href={`tel:${application.phone}`}>
              <Icons.Phone />
              {application.phone}
            </a>
          </span>
        </div>
      </div>

      {/* Detail Grid */}
      <div className="aad-detail-grid">
        {/* Left Column */}
        <div className="aad-detail-left">
          {/* Cover Letter */}
          <div className="aad-card">
            <h3 className="aad-card-title">Cover Letter</h3>
            <div className="aad-cover-letter">
              <p>{application.cover_letter}</p>
            </div>
          </div>

          {/* Portfolio & Links */}
          {(application.portfolio_url || application.linkedin_url) && (
            <div className="aad-card">
              <h3 className="aad-card-title">Portfolio & Links</h3>
              {application.portfolio_url && (
                <div className="aad-link-row">
                  <span className="aad-link-label">Portfolio:</span>
                  <a href={application.portfolio_url} target="_blank" rel="noopener noreferrer" className="aad-link">
                    <Icons.Portfolio />
                    {application.portfolio_url}
                  </a>
                </div>
              )}
              {application.linkedin_url && (
                <div className="aad-link-row">
                  <span className="aad-link-label">LinkedIn:</span>
                  <a href={application.linkedin_url} target="_blank" rel="noopener noreferrer" className="aad-link">
                    <Icons.LinkedIn />
                    {application.linkedin_url}
                  </a>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Right Column */}
        <div className="aad-detail-right">
          {/* Resume */}
          <div className="aad-card">
            <h3 className="aad-card-title">Resume / CV</h3>
            <div className="aad-file-actions">
              {(isPdf || isImage) && (
                <button 
                  className="aad-view-btn"
                  onClick={() => openFileViewer(resumeUrl, resumeFileName)}
                >
                  <Icons.View />
                  View Resume
                </button>
              )}
              <button 
                className="aad-download-btn"
                onClick={() => handleDownload(resumeUrl, resumeFileName)}
              >
                <Icons.Download />
                Download Resume
              </button>
            </div>
            <div className="aad-file-name">
              {isPdf ? <Icons.Pdf /> : isImage ? <Icons.Image /> : <Icons.File />}
              {resumeFileName}
            </div>
          </div>

          {/* Additional Documents */}
          {application.additional_file && (
            <div className="aad-card">
              <h3 className="aad-card-title">Additional Documents</h3>
              <div className="aad-file-actions">
                <button 
                  className="aad-view-btn"
                  onClick={() => openFileViewer(
                    getFileUrl(application.additional_file), 
                    application.additional_file?.split('/').pop() || 'Additional File'
                  )}
                >
                  <Icons.View />
                  View File
                </button>
                <button 
                  className="aad-download-btn"
                  onClick={() => handleDownload(getFileUrl(application.additional_file), application.additional_file?.split('/').pop() || 'Additional File')}
                >
                  <Icons.Download />
                  Download File
                </button>
              </div>
              <div className="aad-file-name">
                <Icons.File />
                {application.additional_file?.split('/').pop()}
              </div>
            </div>
          )}

          {/* Status Update */}
          <div className="aad-card">
            <h3 className="aad-card-title">Application Status</h3>
            <div className="aad-status-update">
              <div className="aad-current-status">
                <span className="aad-status-label">Current Status:</span>
                <span 
                  className="aad-status-badge"
                  style={{ 
                    background: getStatusBackground(application.status),
                    color: getStatusColor(application.status)
                  }}
                >
                  <span className="aad-status-dot" style={{ background: getStatusColor(application.status) }}></span>
                  {getStatusLabel(application.status)}
                </span>
              </div>
              <div className="aad-status-actions">
                <label className="aad-status-action-label">Update Status:</label>
                <select 
                  className="aad-status-select"
                  value={application.status} 
                  onChange={(e) => updateStatus(e.target.value)}
                  disabled={updating}
                >
                  <option value="pending">Pending Review</option>
                  <option value="reviewed">Reviewed</option>
                  <option value="shortlisted">Shortlisted</option>
                  <option value="interviewed">Interviewed</option>
                  <option value="accepted">Accepted</option>
                  <option value="rejected">Rejected</option>
                </select>
                {updating && <span className="aad-updating-spinner"></span>}
              </div>
            </div>
          </div>

          {/* Notes */}
          {application.notes && (
            <div className="aad-card">
              <h3 className="aad-card-title">Notes</h3>
              <div className="aad-notes">
                <p>{application.notes}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminApplicationDetail;